import { BusinessChallengesEnum } from '@platform/client/schemas';
import { FormsInputDropdown, FormsMultilineInput } from '@platform/components';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApplicationPageContent } from '../../application/components/ApplicationPageContent';
import BackgroundImage from '../../application/images/Margaret-Yebei.svg';
import { ChallengeFormPageProps, challengeOptions } from './consts';
import { BusinessChallenges } from '@platform/client';
import { useQueryClient } from '@tanstack/react-query';
import { ChallengeFormBackground } from './ChallengeFormBackground';

export type ChallengeOneFormValues = {
  firstBusinessChallenge: BusinessChallengesEnum | null;
  firstBusinessChallengeDescription: string | null;
};

export const OrganizationChallengeOne = (props: ChallengeFormPageProps) => {
  const { organizationId, onBack, onContinue, challengeData } = { ...props };

  const defaultValues = {
    firstBusinessChallenge: challengeData?.challengeOne?.challenge as BusinessChallengesEnum,
    firstBusinessChallengeDescription: challengeData?.challengeOne?.challengeContext,
  };

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<ChallengeOneFormValues>({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: defaultValues,
  });
  const queryClient = useQueryClient();
  const updateChallengeMutator = BusinessChallenges.useUpdateOrganizationBusinessChallenge({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: BusinessChallenges.getGetOrganizationBusinessChallengesQueryKey(organizationId),
        });
      },
    },
  });

  const submit: SubmitHandler<ChallengeOneFormValues> = (data) => {
    if (data.firstBusinessChallenge && data.firstBusinessChallengeDescription) {
      updateChallengeMutator.mutate({
        organizationId,
        data: {
          challenge: {
            challenge_number: 1,
            challenge_value: data.firstBusinessChallenge,
            challenge_context: data.firstBusinessChallengeDescription,
          },
        },
      });
    }
  };

  return (
    <ChallengeFormBackground
      onBack={onBack}
      onSubmit={handleSubmit(submit)}
      onContinue={onContinue}
      backgroundImage={BackgroundImage}
    >
      <ApplicationPageContent
        title='What are the top 3 challenges your organization is currently working to overcome?'
        description={
          "This helps us connect you with the right skills and expertise. You'll have a chance to explain each one."
        }
      >
        <FormsInputDropdown
          control={control}
          name='firstBusinessChallenge'
          rules={{ required: 'Select a challenge your organization needs help with to continue' }}
          label='First business challenge'
          placeholder='Select one'
          items={challengeOptions}
          type='default'
          error={errors.firstBusinessChallenge}
        />
        <FormsMultilineInput
          control={control}
          label='Tell us more about this challenge'
          placeholder='Enter a description...'
          name={'firstBusinessChallengeDescription'}
          rules={{ maxLength: 500, required: 'Tell us more about this challenge to continue' }}
          formsError={errors.firstBusinessChallengeDescription}
          characterCount={500}
        />
      </ApplicationPageContent>
    </ChallengeFormBackground>
  );
};
